import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=e832821a&"
import script from "./ContentDetail.vue?vue&type=script&lang=ts&"
export * from "./ContentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports